import { apiGet, apiPost } from "../../utils";

export function addUserByAdminAPI(data) {
  return apiPost(`/api/addUserByAdmin`, data);
}
export function giveUserAccessToAdminAPI(data) {
  return apiPost(`/api/giveUserAccessToAdmin`, data);
}
export function getAllSubadminsAdminAPI(data) {
  return apiGet(`/api/getAllSubadminsAdmin`, data);
}
export function getAllAssignedUsersForSubAdminAPI(data) {
  const { subAdminId = "" } = data || {};
  return apiGet(`/api/getAllAssignedUsersForSubAdmin?subAdminId=${subAdminId}`);
}
export function searchUsersAdminAPI(filters) {
  const { search = "" } = filters || {};
  return apiGet(`/api/searchUsersAdmin?search=${search}`);
}
